export {default} from './NavBar.vue'
